export enum ObjectDrawerFilterValueType {
  String = 1,
  Int32 = 2,
  Double = 3,
  Date = 4,
  Enum = 5,
  Boolean = 6,
  Guid = 7,
  Include = 8,
}
